<template>
  <section class="text-style pb-1" >
      <small>סגנון טקסט</small>
      <b-form-checkbox
        id="foreign-words"
        v-model="foreignWords"
        name="foreign-words"
      
      >
        כלול מילים לועזיות
      </b-form-checkbox>
      <b-form-checkbox
        id="base-words"
        v-model="nonBaseWords"
        name="base-words"
       
      >
        כלול מילים שאינן צורת בסיס
      </b-form-checkbox> 
      <b-form-checkbox
        v-if="searchModel === 'tavnit'"
        id="bible-words"
        v-model="nonBibleWords"
        name="bible-words"
       
      >
        כלול מילים תנכיות
      </b-form-checkbox>                 
  </section>
</template>
<script>
  import {Actions} from '@/store/stateChanges'
  export default  {
    name: 'TextStyle',
    computed: {
      hebrew: function () {
        return this.$settings.hebrew    
      },
      nonBaseWords: {
        get () {
          return this.$store.state.preSubmissionOptions.includeNonBase
        },  
        set (value) {
          this.$store.commit('SET_INCLUDE_NON_BASE',  value)
          this.$store.dispatch(Actions.RUN_CHARUZIT)
        }
      },
      foreignWords: {
        get () {
          return this.$store.state.preSubmissionOptions.includeForeign
        },  
        set (value) {
          this.$store.commit('SET_INCLUDE_FOREIGN',  value)
          this.$store.dispatch(Actions.RUN_CHARUZIT)
        }
      },
      nonBibleWords: {
        get () {
          return this.$store.state.preSubmissionOptions.includeTanakh
        },  
        set (value) {
          this.$store.commit('SET_INCLUDE_BIBLE',  value)
        }
      },       
      searchModel () {
        return this.$store.state.searchModel
      }           
    }
  }
</script>
